<template>
    <div><p>adsfakldsfö</p></div>
</template>

<script>
    export default {
        name: 'AlteredInternet',
    }
</script>